import styled from "styled-components";
import WidgetContainerContentBase from "./widget_container_content_base";

export default styled(WidgetContainerContentBase)`
  padding: 20px;
  font-size: 2em;
`;
